
import { mapActions, mapGetters } from 'vuex'
import Placeholder from '../../components/Placeholder'

export default {
  components: {
    'component-placeholder': Placeholder
  },

  data: () => ({
    loading: true,
  }),

  computed: {
    ...mapGetters([
      'deposits'
    ]),

    hasResult () {
      return this.deposits.length && !this.loading
    }
  },

  mounted () {
    this.getDeposits().then(() => {
      this.loading = false
    })
  },

  methods: {
    ...mapActions([
      'getDeposits'
    ])
  }
}
